import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES, STORAGE_KEYS } from 'src/constants'

import AuthDataService from 'src/services/auth.service'
import { I2FAVerificationDto } from 'src/types'

export const useVerify2FA = () => {
  const navigate = useNavigate()

  return useMutation((dto: I2FAVerificationDto) => AuthDataService.verify2FA(dto), {
    onSuccess(data) {
      if (!data) return

      if ('journeyRedirect' in data) {
        setTimeout(() => {
          window.location.replace(data.journeyRedirect)
        }, 1000)
        return
      }

      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)

      navigate(
        data.accountId
          ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
          : data.scannerAccountId
            ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
            : joinAbsRoute(ROUTES.ACCOUNTS),
        {
          replace: true,
        },
      )
    },
  })
}
